export default __webpack_public_path__ + "static/media/aboutImg.cdee7e28.svg";